export const MIN_QUIZ_QUESTION_OPTIONS = 2;

/**
 * Most options a question can have while its options render inline (contest
 * cards, show stage, show producer flows). Channel-page cards fall back to
 * the select-answer modal above it; show surfaces cannot render above it at
 * all.
 */
export const MAX_INLINE_QUIZ_QUESTION_OPTIONS = 5;

/** Per-question option cap for the channel-admin creation flow. */
export const MAX_QUIZ_QUESTION_OPTIONS = 100;

type QuizWithQuestionOptions = {
  quiz_questions?: ReadonlyArray<{
    options?: ReadonlyArray<unknown> | null;
  } | null> | null;
};

/**
 * Single source of truth for "this quiz cannot render on show surfaces":
 * true when any question has more options than fit inline.
 */
export function quizExceedsInlineOptionLimit(
  quiz: QuizWithQuestionOptions,
): boolean {
  return (quiz.quiz_questions ?? []).some(
    (question) =>
      (question?.options?.length ?? 0) > MAX_INLINE_QUIZ_QUESTION_OPTIONS,
  );
}
